module.exports = __webpack_public_path__ + "static/img/IMG_5062.a27497f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/IMG_5062.jpg
// module id = 96Ip
// module chunks = 98